import { useState } from "react";

export interface NodeActionStripProps {
  nodeId: string;
  assetName: string;
  seedanceTargets: readonly { id: string; label: string }[];
  onPreview(): void;
  onDuplicate(): void;
  onStartConnection(): void;
  onDelete(): void;
  onUseAsReference(targetNodeId: string): void;
}

export function NodeActionStrip(props: NodeActionStripProps) {
  const [showTargets, setShowTargets] = useState(false);
  return (
    <aside className="studio-node-action-strip" data-node-id={props.nodeId} aria-label={`${props.assetName} 快捷操作`}>
      <button type="button" onClick={props.onPreview}>查看素材</button>
      <button type="button" onClick={props.onDuplicate}>复制节点</button>
      <button type="button" onClick={props.onStartConnection}>从此节点连线</button>
      <button type="button" aria-expanded={showTargets} onClick={() => setShowTargets((current) => !current)}>作为参考</button>
      <div className="studio-node-action-strip__targets" role="menu" aria-label="选择参考目标" hidden={!showTargets}>
        {props.seedanceTargets.length === 0 ? <span>暂无 Seedance 节点</span> : props.seedanceTargets.map((target) => (
            <button
              key={target.id}
              role="menuitem"
              type="button"
              onClick={() => {
                props.onUseAsReference(target.id);
                setShowTargets(false);
              }}
            >
              {target.label}
            </button>
        ))}
      </div>
      <button className="studio-node-action-strip__delete" type="button" onClick={props.onDelete}>删除节点</button>
    </aside>
  );
}
